export const styles = {
  rows: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  row: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
    alignItems: "stretch",
  },
  rowItem: {
    flex: 1,
    minWidth: 0,
    display: "flex",
  },
  actions: {
    justifyContent: { xs: "stretch", sm: "flex-end" },
    alignItems: "center",
  },
  actionButton: {
    width: { xs: "100%", sm: "fit-content" },
    minWidth: "10rem",
  },
};
